<template>
  <form @submit="submitForm">
    <div class="row">
      <div class="col-12">
        <div class="d-flex flex-column my-4" v-for="questions of generalQuestions">
          <label :for="questions.id" class="wfh-form-label">
            {{ questions.labelText }}
          </label>
          <div class="btn-group btn-group-toggle mt-2 overflow-auto" :id="questions.id">
            <label
                class="btn radio-btn d-flex justify-content-center align-items-center"
                v-bind:class="{ active: formData[questions.formKey] }"
            >
              <i
                  class="fas fa-check-circle mr-1 mr-md-3"
                  style="font-size: 18px;"
                  v-if="formData[questions.formKey]"
              ></i>
              <input
                  type="radio"
                  v-model="formData[questions.formKey]"
                  :value="true"/>
              Yes
            </label>
            <label
                class="btn radio-btn d-flex justify-content-center align-items-center"
                v-bind:class="{ active: !formData[questions.formKey] }"
            >
              <i
                  class="fas fa-check-circle mr-1 mr-md-3"
                  style="font-size: 18px;"
                  v-if="!formData[questions.formKey] "
              ></i>
              <input
                  type="radio"
                  v-model="formData[questions.formKey]"
                  :value="false"/>
              No
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row" v-if="formData.has_tech_team">
      <div class="col-12">
        <div class="wfh-tab-header">Tech Team</div>
        <div class="wfh-paragraph" style="color: #8392a6;">Getting your tech team to work remotely is simple yet
          tricky. Start with the 2 important questions below.
        </div>
      </div>

      <div class="col-12">
        <div class="d-flex flex-column my-4" v-for="questions of techQuestions">
          <label :for="questions.id" class="wfh-form-label">
            {{ questions.labelText }}
          </label>
          <div class="btn-group btn-group-toggle mt-2 overflow-auto" :id="questions.id">
            <label
                class="btn radio-btn d-flex justify-content-center align-items-center"
                v-bind:class="{ active: formData[questions.formKey] }"
            >
              <i
                  class="fas fa-check-circle mr-1 mr-md-3"
                  style="font-size: 18px;"
                  v-if="formData[questions.formKey]"
              ></i>
              <input
                  type="radio"
                  v-model="formData[questions.formKey]"
                  :value="true"/>
              Yes
            </label>
            <label
                class="btn radio-btn d-flex justify-content-center align-items-center"
                v-bind:class="{ active: !formData[questions.formKey] }"
            >
              <i
                  class="fas fa-check-circle mr-1 mr-md-3"
                  style="font-size: 18px;"
                  v-if="!formData[questions.formKey] "
              ></i>
              <input
                  type="radio"
                  v-model="formData[questions.formKey]"
                  :value="false"/>
              No
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group my-4 d-flex justify-content-end">
      <button type="submit" class="btn wfh-btn-primary">
        Next Step
      </button>
    </div>
  </form>
</template>

<script>
import DropDownOptions from '../DropdownOptionsConfig';

export default {
  props: {
    oldData: {
      required: false,
    },
  },

  data () {
    return {
      oldDataParsed: {},
      dropDownOptions: DropDownOptions,
      formData: {
        company_id: null,
        uses_video_conference_tools: true,
        uses_project_management_tools: true,
        has_clear_sops: true,
        set_communications_protocol: true,
        has_tech_team: true,
        schedule_regular_scrums: false,
        uses_git: false,
      },
    };
  },

  computed: {
    generalQuestions () {
      return this.dropDownOptions.companyRemoteReadiness.filter(item => !item.forTech);
    },

    techQuestions () {
      return this.dropDownOptions.companyRemoteReadiness.filter(item => item.forTech);
    },
  },

  methods: {
    async submitForm (e) {
      e.preventDefault();

      await axios.post(window.location.pathname, this.formData);

      window.location = '/dashboard';
    },
  },

  mounted () {
    this.oldDataParsed = JSON.parse(this.oldData);
    const company = this.oldDataParsed.companies[0];
    const remoteMeasures = company.remote_measures;
    this.formData.company_id = company.id;

    Object.keys(this.formData).forEach(key => {
      if (remoteMeasures[key] !== null || typeof remoteMeasures[key] !== undefined) {
        this.formData[key] = remoteMeasures[key];
      }
    });
  },
};
</script>

<style scoped>
.radio-btn {
  width: 50%;
  max-width: 218px;
}
</style>
